import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { allowConciliador } from "../../../redux/actions/allowAction";
import { IState } from "../../../redux/reducers";
import PainelCadastro from "./painelCadastro";

interface Props {
  page: string;
  allowed: boolean;
  allowConciliador: typeof allowConciliador;
  children: React.ReactNode;
}

interface State {
  isPainelCadastroOpen: boolean;
}

class LiberaAcesso extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isPainelCadastroOpen: false };
  }

  closePainelCadastro = () => this.setState({ isPainelCadastroOpen: false });

  componentDidMount() {
    if (this.props.page === "PAINEL_CADASTRO" && !this.props.allowed) {
      this.setState({ isPainelCadastroOpen: true });
    } else if (this.props.page === "LOGGEDIN" && !this.props.allowed) {
      this.props.allowConciliador();
    }
  }

  render() {
    if (!this.props.allowed) {
      return <PainelCadastro isPainelCadastroOpen={true} closePainelCadastro={this.closePainelCadastro} />;
    }
    return (
      <React.Fragment>
        <PainelCadastro isPainelCadastroOpen={this.state.isPainelCadastroOpen} closePainelCadastro={this.closePainelCadastro} />
        {this.props.children}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: IState) => ({
  page: state.loginReducer.page,
  allowed: state.allowReducer.isAllowed,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  allowConciliador: bindActionCreators(allowConciliador, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiberaAcesso);
